import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';

export const convertToLocalStyle = style => _.object(
  _.map(_.keys(style), key => `& ${key}`),
  _.values(style)
);

export const convertToConcatStyle = style => _.object(
  _.map(_.keys(style), key => `&${key}`),
  _.values(style)
);

export const convertToGlobalStyle = (style) => {
  let mergeStyle = style;
  if (_.isArray(style)) {
    mergeStyle = merge(
      {},
      ...style
    );
  }

  return {
    div: mergeStyle,
  };
};
